import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useField } from 'formik';
const UserSettingsTextField = ({ name, label, hint, type, required, disabled, onChangeOverride, step = 1, sx, isLoading, skeletonSx, }) => {
    const [field, meta] = useField(name);
    const error = meta.touched && !!meta.error;
    const errorMessage = error ? meta.error : undefined;
    const widthVar = 'width';
    const width = sx ? sx[widthVar] : '90%';
    if (isLoading) {
        return (_jsx(Skeleton, { variant: "rounded", height: "3rem", width: width, sx: { marginTop: '1rem', ...skeletonSx } }));
    }
    return (_jsx(TextField, { sx: { width: '90%', ...sx }, error: error, name: field.name, value: field.value, onChange: onChangeOverride === null || onChangeOverride === undefined
            ? field.onChange
            : onChangeOverride, onBlur: field.onBlur, type: type, label: label, helperText: error ? errorMessage : hint, required: required, disabled: disabled, InputLabelProps: {
            shrink: true,
        }, variant: "outlined", margin: "normal", inputProps: {
            step: type === 'number' ? step : undefined,
        } }));
};
export { UserSettingsTextField };
